
import vue from 'vue'
import { initWxJSSDK,getPartnerList } from '@/common/js/api.js'
import { wxORzfb } from "../../../common/js/config"
import {
getCookie,
setCookie
} from '../../../common/js/utils.js'
import {
TMap
} from '../../../common/js/map.js'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'


export default {
components: {
Tab,
TabItem,
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Scroller,
Icon,
Sticky
},
methods: {
onItemClick(v) {
console.log('on item click:', v)
let tabChange = false;
if (this.pageInfo.keyword != v) {
tabChange = true;
}
if (v == 0) {
this.pageInfo.keyword = undefined;
} else {
this.pageInfo.keyword = v.toString();
}
if (tabChange) {
this.refresh();
}
},






refresh() {
let self = this
self.pageInfo.pageIndex = 1
self.getList()
},
loadMore() {
let self = this
self.pageInfo.pageIndex++
self.getList()
},
switchTabItem(index) {

this.$vux.loading.show({
text: 'loading'
})
setTimeout(() => {
this.$vux.loading.hide()
this.index01 = index
}, 1000)
},
getList() {
let self = this
getPartnerList({ data: this.pageInfo }).then(function(data) {
self.view.firstLoad = false
if (data.PageIndex > 1) {
self.list = self.list.concat(data.Content)
} else {
self.list = data.Content
}
if (data.Content.length == self.pageInfo.pageSize) {
self.$refs.scroller.enablePullup()
} else {
self.$refs.scroller.disablePullup()
}
setTimeout(() => {
self.$refs.scroller.donePullup()
self.$refs.scroller.donePulldown()
}, 50)
})
},
initLocation() {
let self = this
self.$wechat.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
fail: function(res) {
console.error(res)
},
success: function(res) {
var latitude = res.latitude 
var longitude = res.longitude 
setCookie('latitude', latitude)
setCookie('longitude', longitude)
self.pageInfo.latitude =  latitude
self.pageInfo.longitude = longitude
self.getCityList()
}
})
},
getCityList() {
const self = this
TMap('').then(qq => {
console.log(qq)
const geocoder = new qq.maps.Geocoder({




complete:(res) => {
console.log(res)
const addressComponent = res.detail.addressComponents
self.pageInfo.province = addressComponent.province,
self.pageInfo.city = addressComponent.city
self.pageInfo.county = addressComponent.district
self.getList()
}
})
var coord=new qq.maps.LatLng(self.pageInfo.latitude,self.pageInfo.longitude);
geocoder.getAddress(coord);
})
},
initZfbLocation() {
const self = this
ap.getLocation(function(res) {
var latitude = res.latitude 
var longitude = res.longitude 


setCookie('latitude', latitude)
setCookie('longitude', longitude)
self.pageInfo.latitude =  latitude
self.pageInfo.longitude = longitude
self.getList()
});
},
},
created() {
const self = this
var longitude = getCookie('longitude')
var latitude = getCookie('latitude')
if (!latitude) {
latitude = 39.916527
}
if (!longitude) {
longitude = 116.397128
}
if(wxORzfb == 'wx') {
initWxJSSDK()
vue.wechat.ready(function(res) {
self.initLocation()
})
} else if(wxORzfb == 'zfb') {
self.initZfbLocation()
}
},
activated() {

console.log('activated')
},
data() {
return {
view: {
loading: false,
firstLoad: true
},
status: {
pullupStatus: 'default',
pulldownStatus: 'default'
},
pullupConfig: {
content: '上拉加载更多',
downContent: '松开进行加载',
upContent: '上拉加载更多',
loadingContent: '加载中...'
},
pulldownConfig: {
content: '下拉刷新',
downContent: '下拉刷新',
upContent: '释放刷新',
loadingContent: '加载中...'
},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword:"",
latitude: 0,
longitude: 0,
province:'',
city:'',
county:'',
isClothService:1, //1提供收衣服务,0不提供收衣服务

},
title: '附近网点',
disabled:
typeof navigator !== 'undefined' &&
/iphone/i.test(navigator.userAgent) &&
/ucbrowser/i.test(navigator.userAgent),
list: []
}
}
}



// WEBPACK FOOTER //
// ./src/components/activity/yuexiu/partner.vue